import { t } from 'i18next';
import { and } from './compositions';
import { greaterOrEqualThan, lessOrEqualThan } from './operational';
import { regex } from './type';

export function portNumber() {
  return (value: any) => {
    if (value && and(regex(/^[0-9]*$/g), greaterOrEqualThan(0), lessOrEqualThan(65535))(value) !== true) {
      return t('validators.type.portNumber');
    }
    return true;
  };
}
